// File: src/components/layout/Header.tsx

import React from 'react';
import { useAuthStore } from '../../store/authStore';
import { useLocation } from 'react-router-dom';
import accountIcon from '../../assets/images/accountCircle.svg';
import logoutIcon from '../../assets/images/logoutVector.svg';
import styles from './Header.module.css';

interface HeaderProps {
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const { user, logout } = useAuthStore();
  const location = useLocation();
  const handleLogout = () => {
    logout();
    sessionStorage.clear()
  };

  const getPageTitle = (path: string) => {
    // // This logic can be expanded as you add more pages
    // if (path.startsWith('/batches/')) return 'Batch Details';
    // if (path.startsWith('/task-assignment')) return 'Task Assignment';
    // if (path.startsWith('/analytics')) return 'Analytics';
    // // Add more specific paths here
    // return 'Dashboard'; // A safe default
  };

  return (
    <header className={styles.headerContainer}>
      {/* Left side: Menu button for mobile and Page Title */}
      <div className={styles.leftSide}>
        <button className={styles.menuButton} onClick={onMenuClick} aria-label="Toggle Sidebar">
          {/* A simple hamburger icon SVG */}
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 6H20M4 12H20M4 18H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>
        <h1 className={styles.pageTitle}>{getPageTitle(location.pathname)}</h1>
      </div>

      {/* Right side: User info and logout */}
      <div className={styles.rightSide}>
        <div className={styles.userInfo}>
          <img src={accountIcon} alt="Account" />
          <span>Hello {user?.empName || 'Guest'}</span>
        </div>
        <button className={styles.logoutButton} onClick={handleLogout}>
          <img src={logoutIcon} alt="Logout" />
          <span>Log Out</span>
        </button>
      </div>
    </header>
  );
};

export default Header;